<template>
  <div class="loading" :class="{ block: type === 'block', top: align === 'top', bottom: align === 'bottom' }">
    <img src="@/assets/common/ui/loading.gif" width="200" height="230" />
  </div>
</template>

<script>
export default {
  name: 'AppLoading',
  props: {
    //* type: full, block
    type: {
      type: String,
      default: 'full',
    },
    //* type: top, center, bottom
    align: {
      type: String,
      default: 'center',
    },
  },
};
</script>

<style lang="scss">
.loading {
  background: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  &.block {
    position: absolute;
    z-index: 1;
  }

  &.top {
    align-items: flex-start;
    padding-top: 45px;
  }

  &.bottom {
    align-items: flex-end;
  }
}
</style>
